<template>
    <div>
        <div class="categorias-container">
            <div class="categorias">
                <button
                  v-for="(categoria, index) in categories"
                  :key="index"
                  :class="{ active: categoria === initialCategory  }"
                  @click="changeCategory(categoria)"
                  :disabled="desactivar"
                >
                  {{ categoria }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        categories: {
            type: Array,
            required: true,
        },
        initialCategory: {
            type: String,
            default: "",
        },
        desactivar: {
            type: Boolean,
            required: true,
        },
    },
    methods: {
        changeCategory(category) {
            this.selectedCategory = category;
            this.$emit("changeCategory", category); 
        },
    },
};
</script>


<style scoped>
  .categorias-container {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    background-color: #333333;
    white-space: nowrap;
    scroll-snap-type: x mandatory;
  }

  .categorias {
    display: flex;
    gap: 10px;
    scroll-snap-align: start;
  }

  .categorias button {
    background: none;
    border: none;
    color: #ffffff;
    font-size: 16px;
    cursor: pointer;
    padding: 15px 35px;
    border-bottom: 3px solid transparent;
    transition: all 0.3s ease;
    flex-shrink: 0; 
    scroll-snap-align: center; 
  }

  .categorias button.active {
    border-bottom: 5px solid var(--altcolor);
    font-weight: bold;
    background-color: #000000; 
  }

  .categorias button:hover {
    color: var(--altcolor); 
  }

  .categorias button:disabled {
    color: #808080; 
  }
</style>